import { render, staticRenderFns } from "./auditcompanydetail.vue?vue&type=template&id=50c8dc02&scoped=true"
import script from "./auditcompanydetail.vue?vue&type=script&lang=js"
export * from "./auditcompanydetail.vue?vue&type=script&lang=js"
import style0 from "./auditcompanydetail.vue?vue&type=style&index=0&id=50c8dc02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c8dc02",
  null
  
)

export default component.exports